import { FormattedMessage } from 'react-intl'
import { styled } from '@mui/material'
import { Button, DialogFooter } from '@carto/meridian-ds/components'
import { InfoOutlined } from '@mui/icons-material'

const HelpIcon = styled(InfoOutlined)(({ theme }) => ({
  color: theme.palette.text.secondary
}))

function ConnectionShareDialogFooter({ onClose, loading }: { onClose: () => void; loading?: boolean }) {
  return (
    <DialogFooter
      alertProps={{ icon: <HelpIcon /> }}
      alertContent={<FormattedMessage id="connections.shareDialog.sharingNotice" />}
    >
      <Button onClick={onClose} loading={!!loading}>
        <FormattedMessage id="common.button.done" />
      </Button>
    </DialogFooter>
  )
}

export default ConnectionShareDialogFooter
